import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'topo-logo',
    templateUrl: './topo-logo.component.html',
    styleUrls: ['./topo-logo.component.scss'],
    standalone: false
})
export class TopoLogoComponent implements OnInit {
  @Input() isEditMode = false;
  @Input() height = 32;
  @Input() theme: string;

  constructor() {}

  ngOnInit(): void {
    if (!this.theme) {
      this.theme = 'default';
    }
  }
}
